import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { ChangeEvent, CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { PiDotsSixVertical, PiTrash } from 'react-icons/pi';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { animateLayoutChanges } from 'utils/dnd/dndUtilities';
import './ContractAgreementDetailSelectOptionItem.scss';

interface IContractAgreementDetailSelectOptionItemProps {
  id: number;
  removeOption: () => void;
}

const ContractAgreementDetailSelectOptionItem = ({
  id,
  removeOption,
}: IContractAgreementDetailSelectOptionItemProps) => {
  const { setDetailValue, itemName, displayMode } = useFormikContractHelpers();
  const { t } = useTranslation();

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, animateLayoutChanges });

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.3 : 1,
  };
  const onOptionChange = (event: ChangeEvent<HTMLInputElement>) => {
    setDetailValue<string>(
      `content.selectAgreementTemplate.options[${id - 1}]`,
      event.target.value
    );
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className='contract-details-select-options-item'>
      {!displayMode && (
        <Button
          onlyIcon
          isClear
          size='compact'
          className='show-on-hover'
          onClick={removeOption}
          variant={BUTTON_VARIANT.remove}>
          <Button.Description description={t('button.remove')} />
          <Button.Icon icon={<PiTrash />} />
        </Button>
      )}
      <FormInput.Text
        name={`${itemName}.content.selectAgreementTemplate.options[${id - 1}]`}
        onChange={e => onOptionChange(e)}
        placeholder={t('input.placeholder.select-option')}
        displayMode={displayMode}
      />
      {!displayMode && (
        <Button onlyIcon isClear size='compact' {...attributes} {...listeners}>
          <Button.Description description={t('button.reorder')} />
          <Button.Icon icon={<PiDotsSixVertical />} />
        </Button>
      )}
    </div>
  );
};

export default ContractAgreementDetailSelectOptionItem;
